var map = {
	"./de/btn-download-steam.png": "WcyD",
	"./en/btn-download-steam.png": "WoHZ",
	"./es/btn-download-steam.png": "QZyk",
	"./fr/btn-download-steam.png": "eH7F",
	"./ja/btn-download-steam.png": "96Yv",
	"./ko/btn-download-steam.png": "T/rW",
	"./pt/btn-download-steam.png": "wouZ",
	"./ru/btn-download-steam.png": "Ry1j",
	"./tc/btn-download-steam.png": "tJox",
	"./th/btn-download-steam.png": "Lm8z",
	"./zh-Hant/btn-download-steam.png": "j5Re"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "M+Lw";